<template slot-scope="scope">
    <div ref="layout" v-loading="loading" class="page-form page-base">
      <h3 class="title">销售计划签约新增单</h3>
      <div class="form-container">
        <errors-list :errors="errorList" />
        <div class="tools">
          <!-- 页面详情状态 -->
          <form-button @click="$router.go(-1)">返回</form-button>
          <form-button name="保存" @click="saveData('SAVE')"/>
          <form-button name="提交" @click="saveData('SUBMIT')" />
          <!-- <form-button name="审核提交" @click="saveData('approve')" /> -->
          <!-- <form-button name="退回" @click="saveData('cancel')" /> -->
        </div>
        <el-form
          ref="form"
          inline
          size="mini"
          :show-message="false"
          :disabled="isEdit"
          label-width="100px"
          :model="conditions"
          :rules="rules"
        >
          <common-title title="抬头明细" />
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="单据编号">
                <el-input :value="conditions.plan_cntr_no" disabled />
              </el-form-item>
            </el-col>

            <el-col :lg="8" :md="12">
              <el-form-item label="单据类型">
                <el-select :value="conditions.order_type" placeholder="" disabled>
                  <el-option
                  v-for="item in selectDataOptions['A0072']"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="计划年度">
                <el-input :value="conditions.gjahr" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item prop="customer" label="客户编号" required>
                <wly-input
                  @enter="handleEnter"
                  @handleSuffixClick="openDialog($event, '客户选择')"
                  v-model="conditions.customer"
                  input-type="customer"
                  :query-params="{mode: 'SPCT'}"
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="客户名称">
                <el-input :value="conditions.cust_name" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="客户类型">
                <el-select :value="conditions.customer_type" disabled clearable>
                  <el-option
                    v-for="item in selectDataOptions['A0009']"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="计划类型" prop="plan_type" required>
                <el-select v-model="conditions.plan_type" clearable @change="changeVal($event,'plan_type')">
                  <el-option
                    v-for="item in planTypeList"
                    :key="item.newPlanType"
                    :label="item.newPlanTypeName"
                    :value="item.newPlanType"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="存货分类" prop="chfl" required>
                <el-select v-model="conditions.chfl" clearable @change="changeVal($event,'chfl')">
                  <el-option
                    v-for="item in chflList"
                    :key="item.chfl"
                    :label="item.chflName"
                    :value="item.chfl"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="营销单元" prop="sal_center">
                <!-- :disabled="isEdit" -->
                <el-select
                  v-model="conditions.sal_center"
                  placeholder=""
                  @change="saleCenterChange"
                  disabled
                >
                  <el-option
                    v-for="item in saleCenterLists"
                    :key="item.zzfld00001h"
                    :label="item.mc_short"
                    :value="item.zzfld00001h"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="可组合签约产品年销售金额" class="lg-label" >
                <el-input v-model="conditions.combination_amt" type="number"/>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <span class="mark">(万/年) (有组合签约客户需填写) </span>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="大区副总审核" prop="zassign">
                <el-select
                  v-model="conditions.zassign"
                  @change="zassignChange($event)"
                  placeholder=""
                  :disabled="role.ROLE !== 'WLY025'"
                >
                  <el-option
                    v-for="item in zassignLists"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"

                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12" v-if="conditions.zassign">
              <el-form-item label="大区副总" prop="assign">
                <el-select
                  v-model="assignLists"
                  @change="assignBpChange($event)"
                  placeholder=""
                  multiple
                >
                <el-option
                  v-for="item in deputyLists"
                  :key="item.partner"
                  :label="item.name"
                  :value="item.partner"
                />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="建议签约量">
                <el-input :value="conditions.pre_aloc_plan_qty" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="建议签约下限">
                <el-input :value="conditions.pre_aloc_min_qty" disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="建议签约上限">
                <el-input :value="conditions.pre_aloc_max_qty" disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="签约说明" prop="signing_note" required>
                <el-input
                  v-model="conditions.signing_note"
                  type="textarea"
                  :disabled="isEdit"
                  rows="4"
                  maxlength="2000"
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="特殊说明">
                <el-input
                  v-model="conditions.spec_note"
                  rows="4"
                  type="textarea"
                  maxlength="2000"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>

          <common-title title="状态" />
          <el-row :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="创建人">
                <el-input :value="conditions.uname_text" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="创建时间">
                <el-input :value="conditions.datum" disabled />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="状态">
                <el-select :value="conditions.status" placeholder="" disabled>
                  <el-option
                    v-for="item in selectDataOptions['A0071']"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-container">
        <TableCommon :title="countYearArea" :custome-config="() => vxeShowCustom('gridOptionArea')">
          <template #button>
          </template>
          <vxe-grid
            ref="gridOptionArea"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="240"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptionArea.columns"
            :data="gridOptionArea.data"
          >
          </vxe-grid>
        </TableCommon>

        <TableCommon :title="countYearChannel" :show-custome="false">
          <el-checkbox-group>
            <el-row>
              <el-col v-for="item in channelList" :key="item.channel" :lg="6" :md="8">
                <el-checkbox :label="item.channel" disabled>{{ item.chlName }}</el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </TableCommon>
        <!-- <TableCommon title="历史数据" :custome-config="() => vxeShowCustom('xTable2')">
          <vxe-grid
            ref="xTable2"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="240"
            max-height="500"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptionsPlanDetail.columns"
            :data="gridOptionsPlanDetail.data"
            :span-method="mergeRowMethod"
          >
          </vxe-grid>
        </TableCommon> -->
        <TableCommon :title="countYearPlan" :showCustome="showCustome" :custome-config="() => vxeShowCustom('orderDetail')">
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="auto"
            max-height="300"
            align="center"
            size="medium"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          >
            <!-- <template #toolbar /> /^(-?[1-9][0-9]*|0)$/-->
            <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
              <div :key="item.field">
                <el-input
                  v-if="
                    gridOptions.columnsFieldTypes[item.field] == 'input'
                  "
                  v-model="row[item.field]"
                  size="mini"
                  oninput="value=value.replace(/[^\-?\d]/g, '')"
                  @keyup.enter.native="saveSaleItem(item.field, row)"
                />
              </div>
            </template>
          </vxe-grid>
        </TableCommon>
        <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
          <template #button>
            <el-upload
              ref="upload"
              accept=".png,.pdf,.jpg"
              action=""
              :on-change="uploadFile"
              :show-file-list="false"
              :auto-upload="false"
            >
              <table-button slot="trigger" :disabled="isEdit" name="upload" tip="上传" />
            </el-upload>
            <table-button name="delete" :disabled="isEdit" tip="删除" @click="delUpload" />
          </template>
          <vxe-grid
            ref="fileTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="240"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptionsFile.columns"
            :data="gridOptionsFile.data"
          >
            <!-- <template #toolbar /> -->
            <template #filename="{ row }">
              <span class="blue" @click="downLoadFile(row)">{{ row.filename }}</span>
            </template>
          </vxe-grid>
        </TableCommon>
      </div>
      <!-- 通用弹窗情况 -->
      <el-dialog
        v-dialogDrag
        title="客户选择"
        :visible.sync="showDialog"
        width="70%"
        :append-to-body="true"
      >
        <template v-if="showDialog">
          <ClientSelect ref="dialogSelect" mode="SPCT"/>
        </template>

        <div slot="footer">
          <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
          <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">提交</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import { findchflList, findnewPlanTypeList, findSaleplanHistory, findContractArea, findContractChannel, findBrandPrice} from '@/api/signing'
import {spctNewOrder, getSpctById, getCenterFz} from '@/api/sap/signing-sap'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
import { sapDownloadFile } from '@/utils/frontExport'
import { formatSapTime, formatSapDate, formatSapFileSize } from '@/mixins/index'
import { formatWlyYear } from '@/utils/handleFormData'

export default {
    components: {
      ClientSelect
    },
    data() {
        return {
          zassignLists: [
            {
              key: 'X',
              value: '是'
            },
            {
              key: '',
              value: '否'
            }
          ],
          checkAssign: [],
          disCheckList: [],
          deputyLists: [],
          assignLists: [],
          copyChflList: [],
          showCustome: false,
          mode: '',
          saleCenterLists: [],
          chflList: [],
          planTypeList: [],
          countYearArea: '',
          countYearChannel: '',
          countYearPlan: '',
          showDialog: false,
          selectDataOptions: {},
          rules: {
            customer: [{ required: true, message: '请选择客户', trigger: 'change' }],
            plan_type: [{ required: true, message: '请选择计划类型', trigger: 'change' }],
            chfl: [{ required: true, message: '请选择存货分类', trigger: 'change' }],
            signing_note: [{ required: true, message: '请填写签约说明', trigger: 'change' }],
          },
          loading: false,
          errorList: [],
          conditions: {
            customer: '',
            cust_name: '',
            plan_type: '',
            chfl: '',
            signing_note: '',
            customer_type: '',
            sal_center: '',
            saleCenterTextView: '',
            brandTextView: '',
            planTypeTextView: '',
            gjahr: 2024,
            order_type: 'ZP01',
            cntrname: '',
            status: 'E001', // 状态
            ZZFLD000001Name: '',
            ZZFLD00003E: '',
            datum: '',
            uname_text: '',
            combination_amt: '',
            pre_aloc_plan_qty: '',
            pre_aloc_min_qty: '',
            pre_aloc_max_qty: ''
          },
          gridOptionsPlanDetail: {
            columns: [
              { type: 'seq', field: 'seq', title: '序号', width: 50 },
              // {
              //   field: 'customerCode',
              //   title: '客户编号',
              // },
              // {
              //   field: 'customerName',
              //   title: '客户名称',
              // },
              // {
              //   field: 'customerType',
              //   title: '客户类型',
              // },
              // {
              //   field: 'saleCenter',
              //   title: '营销单元',
              // },
              // {
              //   field: 'saleArea',
              //   title: '合同区域',
              // },
              // {
              //   field: 'brand',
              //   title: '存货分类',
              // },
              // {
              //   field: 'newPlanType',
              //   title: '新计划类型',
              // },
              // {
              //   field: 'planTypeTextView',
              //   title: '计划类型',
              // },
              // {
              //   field: 'histPlanQty',
              //   title: '历史计划量',
              // },
              {
                field: 'planQty21',
                title: '2021年计划量',
              },
              {
                field: 'billQty21',
                title: '2021年开票数量',
              },
              {
                field: 'planQty22',
                title: '2022年计划量',
              },
              {
                field: 'billQty22',
                title: '2022年开票数量',
              },
              {
                field: 'planQty23',
                title: '2023年计划量',
              },
              {
                field: 'billQty23',
                title: '2023年开票数量',
              },
              {
                field: 'deliverQty21',
                title: '2021年发货数量',
              },
              {
                field: 'deliverQty22',
                title: '2022年发货数量',
              },
              {
                field: 'deliverQty23',
                title: '2023年发货数量',
              },
              {
                field: 'breakRuleQty',
                title: '2023年违规数量',
              },
              {
                field: 'omitQty',
                title: '遗留扣减量',
              },
              {
                field: 'selledStock',
                title: '库存',
              },
              {
                field: 'selledQty21',
                title: '2021年动销量',
              },
              {
                field: 'selledQty22',
                title: '2022年动销量',
              },
              {
                field: 'selledQty23',
                title: '2023年动销量',
              },
              // {
              //   field: 'signedQty',
              //   title: '参考量',
              // },
            ],
            data: []
          },
          gridOptionsFile: {
            columns: [
              { type: 'checkbox', title: '', field: 'checkbox', width: 40 },
              {
                field: 'filename',
                title: '附件名称',
                slots: { default: 'filename' }
              },
              { field: 'mimetype', title: '附件类型' },
              {
                field: 'filelength',
                title: '大小',
                formatter: ({ cellValue }) => formatSapFileSize(cellValue)
              },
              {
                field: 'created_date',
                title: '上传日期',
                formatter: ({ cellValue }) => formatSapDate(cellValue)
              },
              {
                field: 'created_time',
                title: '上传时间',
                formatter: ({ cellValue }) => formatSapTime(cellValue)
              }
            ],
            data: [],
            delData: []
          },
          gridOptionArea: {
            columns: [
              { type: 'seq', field: 'seq', title: '序号', width: 50 },
              { field: 'regnName', title: '经营区域/省份/直销市',},
              { field: 'cityName', title: '经营区域/城市/地区',},
              { field: 'streetName', title: '经营区域/区县',}
            ],
            data: []
          },
          gridOptions: {
            columns: [
              {
                field: 'total',
                title: '申请计划量',
                width: 95,
                slots: { default: 'total' }
              },
              {
                field: 'plan_qty_12',
                title: '12月份',
                slots: { default: 'plan_qty_12' }
              },
              {
                field: 'plan_qty_1',
                title: '1月份',
                slots: { default: 'plan_qty_1' }
              },
              {
                field: 'plan_qty_2',
                title: '2月份',
                slots: { default: 'plan_qty_2' }
              },
              {
                field: 'plan_qty_3',
                title: '3月份',
                slots: { default: 'plan_qty_3' }
              },
              {
                field: 'plan_qty_4',
                title: '4月份',
                slots: { default: 'plan_qty_4' }
              },
              {
                field: 'plan_qty_5',
                title: '5月份',
                slots: { default: 'plan_qty_5' }
              },
              {
                field: 'plan_qty_6',
                title: '6月份',
                slots: { default: 'plan_qty_6' }
              },
              {
                field: 'plan_qty_7',
                title: '7月份',
                slots: { default: 'plan_qty_7' }
              },
              {
                field: 'plan_qty_8',
                title: '8月份',
                slots: { default: 'plan_qty_8' }
              },
              {
                field: 'plan_qty_9',
                title: '9月份',
                slots: { default: 'plan_qty_9' }
              },
              {
                field: 'plan_qty_10',
                title: '10月份',
                slots: { default: 'plan_qty_10' }
              },
              {
                field: 'plan_qty_11',
                title: '11月份',
                slots: { default: 'plan_qty_11' }
              },
              {
                field: 'aloc_total_qty',
                title: '月度计划量合计',
                width: 120,
                slots: { default: 'aloc_total_qty' }
              },
              {
                field: 'price',
                title: '单价',
                width: 60,
              },
              {
                field: 'total_price',
                title: '总金额(万元)',
                width: 70,
              },
            ],
            data: [
              {
                total: '',
                plan_qty_1: '',
                plan_qty_2: '',
                plan_qty_3: '',
                plan_qty_4: '',
                plan_qty_5: '',
                plan_qty_6: '',
                plan_qty_7: '',
                plan_qty_8: '',
                plan_qty_9: '',
                plan_qty_10: '',
                plan_qty_11: '',
                plan_qty_12: '',
                price:'',
                total_price: ''
              }
            ],
            columnsFieldTypes: {
              total: 'input',
              aloc_total_qty: 'input',
              plan_qty_1: 'input',
              plan_qty_2: 'input',
              plan_qty_3: 'input',
              plan_qty_4: 'input',
              plan_qty_5: 'input',
              plan_qty_6: 'input',
              plan_qty_7: 'input',
              plan_qty_8: 'input',
              plan_qty_9: 'input',
              plan_qty_10: 'input',
              plan_qty_11: 'input',
              plan_qty_12: 'input',
            }
          },
          validRules: {},
          chanelCheckList: [],
          channelList: [],
        }
    },
    computed: {
      // 提交+保存按钮
      isSave(){
        const arr = ['WLY013','WLY014','WLYALL']
        if(arr.indexOf(this.role.ROLE) > -1 ){
          return true
        }
        return false
      },
      isEdit() {
          return false
      },
      ...mapGetters(['customerInfo', 'role'])
    },

    watch:{

    },
    created() {
      this.conditions.gjahr = formatWlyYear()
      const {plan_cntr_no} = this.$route.query
      if(plan_cntr_no){
        this.getSpctById(plan_cntr_no)
      }
      this.getSelectDictDataOrigin('A0009')
      this.getSelectDictDataOrigin('A0071')
      this.getSelectDictDataOrigin('A0072')
      this.getSelectDictDataOrigin('A0043')
      this.getSelectDictDataOrigin('orgList')
      // this.getContractQd()
      this.conditions.uname_text = this.role.login_user
      this.conditions.datum = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
      this.countYearArea = this.conditions.gjahr + '年营销区域'
      this.countYearChannel = this.conditions.gjahr +'年营销渠道'
      this.countYearPlan = this.conditions.gjahr +'年计划量'
    },
    methods: {
      assignBpChange(list){
      this.checkAssign = []
      this.conditions.assign = []
      list.forEach(ele => {
        this.deputyLists.forEach(item => {
          if(ele === item.partner){
            this.conditions.assign.push(item)
            this.checkAssign.push(item)
          }
        });
      });
    },
      async getCenterFz(data){
        const params = {
          user_bp: this.role.USER_BP,
          sal_center: [
          {
            high: "",
            low: data.sal_center,
            option: "EQ",
            sign: "I",
          }
          ],
        }
        const res = await getCenterFz(params)
        this.deputy = res.data.length > 0
        this.deputyLists = res.data
      },
      zassignChange(e){
        // e && this.getCenterFz(this.conditions)
        this.conditions.assign = []
        this.assignLists = []
      },
      // 通用行合并函数（将相同多列数据合并为一行）
      mergeRowMethod ({ row, _rowIndex, column, visibleData }) {
        // fields是哪些需要合并的单元格
        const fields1= [
          'breakRuleQty',
          'omitQty',
          'selledStock',
          'selledQty21',
          'selledQty22',
          'selledQty23',
        ]
        if (row[column.property] && fields1.includes(column.property)) {
          const prevRow = visibleData[_rowIndex - 1]
          let nextRow = visibleData[_rowIndex + 1]
          // 当满足以下条件才去合并上面的单元格
          if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['brandTextView'] === row['brandTextView'] && prevRow['saleCenterTextView'] === row['saleCenterTextView']) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let countRowspan = 1
            while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['brandTextView'] === row['brandTextView'] && nextRow['saleCenterTextView'] === row['saleCenterTextView']) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }else if (row[column.property] && column.property === 'signedQty') {
          // const prevRow = visibleData[_rowIndex - 1]
          // let nextRow = visibleData[_rowIndex + 1]
          // // 当满足以下条件才去合并上面的单元格
          // if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['newPlanTypeTextView'] === row['newPlanTypeTextView'] && prevRow['brandTextView'] === row['brandTextView']) {
          //   return { rowspan: 0, colspan: 0 }
          // } else {
          //   let countRowspan = 1
          //   while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['newPlanTypeTextView'] === row['newPlanTypeTextView'] && nextRow['brandTextView'] === row['brandTextView']) {
          //     nextRow = visibleData[++countRowspan + _rowIndex]
          //   }
          //   if (countRowspan > 1) {
          //     return { rowspan: countRowspan, colspan: 1 }
          //   }
          // }
        }
      },
      // 查单价
      async findBrandPrice(type){
        const params = {
          brand: this.conditions.chfl,
          customerCode: this.conditions.customer,
          planType: this.conditions.plan_type,
          saleCenter: this.conditions.sal_center,
          year: this.conditions.gjahr
        }
        const { data } = await findBrandPrice(params)
        this.gridOptions.data[0].price = data || 0
        if(type === 'chfl' && this.gridOptions.data[0].aloc_total_qty){
          const bottle = this.conditions.chfl ===  '011102'? 2 : 6
          let total = this.gridOptions.data[0].aloc_total_qty * bottle * this.gridOptions.data[0].price/10000
          total = Math.round((total + Number.EPSILON)*10000) / 10000
          this.gridOptions.data[0].total_price = total.toFixed(4)
        }
      },
      saveSaleItem(title ,row){
        console.log(title, row,'090')
        const arr = [1,2,3,4,5,6,7,8,9,10,11,12]
        // this.gridOptions.data = [{ ...row }]
        this.gridOptions.data = JSON.parse(JSON.stringify(this.gridOptions.data))
        const bottle = this.conditions.chfl ===  '011102'? 2 : 6
        // 平分数量
        if(title === 'aloc_total_qty'){
          const qty = this.gridOptions.data[0].aloc_total_qty - 0
          if(qty &&  Math.floor(qty/12) === (qty/12)){
            arr.forEach(ele => {
              this.gridOptions.data[0]['plan_qty_'+ele] = (qty/12)
            });
            let num = qty * bottle * this.gridOptions.data[0].price/10000
            num = Math.round((num + Number.EPSILON)*10000) / 10000
            this.gridOptions.data[0].total_price = num.toFixed(4)
          }
        }else{
           // 计算总价
          let num  = 0
          arr.forEach(ele => {
            if(this.gridOptions.data[0]['plan_qty_'+ele]){
              num += this.gridOptions.data[0]['plan_qty_'+ele] - 0
            }
          });
          this.gridOptions.data[0].aloc_total_qty = num
          let total = num * bottle * this.gridOptions.data[0].price/10000
          total = Math.round((total + Number.EPSILON)*10000) / 10000
          this.gridOptions.data[0].total_price = total.toFixed(4)
        }
      },
      // 根据签约号查询详情
      async getSpctById(plan_cntr_no){
        const params = {
          user_bp: this.role.USER_BP,
          plan_cntr_no,
          dept_code: this.role.deptCode,
        }
        const res = await getSpctById(params)
      },
      changeVal(e,type){
        if(this.conditions.customer && this.conditions.sal_center && this.conditions.chfl && this.conditions.plan_type){
          this.findSaleplanHistory()
          this.findContractArea()
          this.findContractChannel()
          this.findBrandPrice(type)
        }
        if(type === 'plan_type'){
          if (e === 'V116') {
            const allow = ['011102','0122','0133','020701']
            this.chflList = this.copyChflList.filter(item => allow.includes(item.chfl))
            if (!allow.includes(this.conditions.chfl)) {
              this.conditions.chfl = ''
            }
          } else {
            const allow = ['0102','010802','0122','0176']
            this.chflList = this.copyChflList.filter(item => allow.includes(item.chfl))
            if (!allow.includes(this.conditions.chfl)) {
              this.conditions.chfl = ''
            }
          }
        }
      },
      // 存货分类接口
      async findchflList(){
        const res = await findchflList({customerCode: this.conditions.customer})
        this.chflList = res.data || []
        this.copyChflList = res.data || []
      },
      // 计划类型
      async findnewPlanTypeList(){
        const res = await findnewPlanTypeList({customerCode: this.conditions.customer})
        this.planTypeList = res.data
      },
      // 历史数据
      async findSaleplanHistory(){
        const params = {
          brand: this.conditions.chfl,
          customerCode: this.conditions.customer,
          planType: this.conditions.plan_type,
          saleCenter: this.conditions.sal_center,
          year: this.conditions.gjahr
        }
        const res = await findSaleplanHistory(params)
        // this.conditions = { ...this.conditions, ...res.data, pre_aloc_plan_qty: res.data.signedQty}
        this.gridOptionsPlanDetail.data = res.data
        this.conditions.pre_aloc_plan_qty = res.data[0]?.signedQty
        this.conditions.pre_aloc_min_qty = res.data[0]?.signedDown
        this.conditions.pre_aloc_max_qty = res.data[0]?.signedUp
        this.conditions.viola_qty = res.data[0]?.breakRuleQty
        this.conditions.legacy_deduction = res.data[0]?.omitQty

      },
      // 销售区域
      async findContractArea(){
        const params = {
          brand: this.conditions.chfl,
          customerCode: this.conditions.customer,
          saleCenter: this.conditions.sal_center,
          year: this.conditions.gjahr - 1,
          newPlanType: this.conditions.plan_type,
        }
        const res = await findContractArea(params)
        this.gridOptionArea.data = res.data
      },
      // 销售渠道
      async findContractChannel(){
        const params = {
          brand: this.conditions.chfl,
          customerCode: this.conditions.customer,
          saleCenter: this.conditions.sal_center,
          year: this.conditions.gjahr - 1,
          newPlanType: this.conditions.plan_type,
        }
        const res = await findContractChannel(params)
        this.channelList = res.data || []
      },
      async saveData(mode){
        this.errorList = []
        this.$refs.form.validate(async(val, err) => {
          if (val) {
            // const planQty23 = this.gridOptionsPlanDetail.data[0].planQty23 - 0
            const trimOptions = this.gridOptions.data[this.gridOptions.data.length - 1]
            if(trimOptions.total - 0 !== trimOptions.aloc_total_qty - 0){
              this.errorList.push('计划量调整明细的申请计划量不等于月度计划量合计')
              return
            }
            // if(( trimOptions.total-0 > (planQty23 - 0) * 1.1 || trimOptions.total-0 < (planQty23 - 0) * 0.9) && !this.conditions.spec_note){
            //   this.errorList.push('请填写特殊说明')
            //   return
            // }
            // let monthNum1 = trimOptions.plan_qty_12 - 0 + trimOptions.plan_qty_1 - 0 + trimOptions.plan_qty_2 - 0
            // let monthNum2 = trimOptions.plan_qty_3 - 0 + trimOptions.plan_qty_4 - 0 + trimOptions.plan_qty_5 - 0
            // let monthNum3 = trimOptions.plan_qty_6 - 0 + trimOptions.plan_qty_7 - 0 + trimOptions.plan_qty_8 - 0
            // let monthNum4 = trimOptions.plan_qty_9 - 0 + trimOptions.plan_qty_10 - 0 + trimOptions.plan_qty_11 - 0
            // if(monthNum1 - 0 < planQty23 * 0.1 || monthNum2 - 0 < planQty23 * 0.1 || monthNum3 - 0 < planQty23 * 0.1 || monthNum4 - 0 < planQty23 * 0.1){
            //   this.errorList.push('每个季度不能低于总量10%')
            //   return
            // }
            // 选择渠道
            const qudao = []
            this.channelList.length > 0 && this.channelList.forEach((item) => {
              qudao.push({
                ...item,
                chl_name: item.chlName
              })
            });
            // 区域
            const area = []
            this.gridOptionArea.data.length > 0 && this.gridOptionArea.data.forEach(ele => {
              area.push({
                ...ele,
                city_code: ele.cityCode,
                city_name: ele.cityName,
                regn_name: ele.regnName,
                street_name: ele.streetName,
              })

            });
            let lssl = []
            this.gridOptionsPlanDetail.data.length > 0 && this.gridOptionsPlanDetail.data.forEach(ele => {
              lssl.push({
                plan_cntr_no: this.conditions.plan_cntr_no,
                plan_qty_21:ele.planQty21 ,
                plan_qty_22:ele.planQty22 ,
                plan_qty_23:ele.planQty23 ,
                bill_qty_21:ele.billQty21 ,
                bill_qty_22:ele.billQty22 ,
                bill_qty_23:ele.billQty23 ,
                deliver_qty_21:ele.deliverQty21 ,
                deliver_qty_22:ele.deliverQty22 ,
                deliver_qty_23:ele.deliverQty23 ,
                // left_qty_21:ele. ,
                // left_qty_22:ele. ,
                // left_qty_23:ele. ,
                selled_stock:ele.selledStock ,
                selled_qty_21:ele.selledQty21 ,
                selled_qty_22:ele.selledQty22 ,
                selled_qty_23:ele.selledQty23 ,
              })
            });
            const params = {
              mode,
              user_bp: this.role.USER_BP,
              head: this.conditions,
              qudao,
              attachment: this.gridOptionsFile.data,
              area,
              item: this.gridOptions.data,
              ext_sys: '',
              lssl,
              dept_code: this.role.deptCode,
              assign: this.checkAssign
            }
            const res = await spctNewOrder(params)
            this.errorList = []
            if(res.msgtype === 'S'){
              this.$router.push({
                path: '/wly/qy/sale-plan-edit',
                query: {
                  plan_cntr_no: res.data.head.plan_cntr_no,
                  order_type: res.data.head.order_type,
                  status: res.data.head.status,
                }
              })
            }else{
              this.errorList.push(res.message)
            }
          } else {
            this.errorList = this.$utilsCommon.filterErrorMsg(err)
            return false
          }
        })
      },
      // 渠道类型
      // async getContractQd() {
      //   const { DATA } = await apiGetContractQd()
      //   this.$set(this.selectDataOptions, 'contractQd', DATA)
      // },
      async uploadFile(file) {
        // console.log(file);
        const _this = this
        const reader = new FileReader()
        reader.readAsArrayBuffer(file.raw)
        var strArr = []
        reader.onload = function() {
          var unitArray = new Uint8Array(this.result)
          for (var i = 0; i < unitArray.length; i++) {
            var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
            if (u_arr16.length < 2) {
              u_arr16 = '0' + u_arr16
            }
            strArr.push(u_arr16)
          }

          strArr = strArr.join('')
          const dateTime = new Date().getTime()

          const fileData = {
            filename: file.name,
            mimetype: file.raw.type,
            doc_type: file.raw.type,
            xcontent: strArr,
            filelength: file.size,
            zzfld00002d: _this.role.USER_BP,
            uname_text: _this.role.login_user,
            created_date: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
            created_time: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
          }

          _this.gridOptionsFile.data.unshift(fileData)
        }
      },
      // 删除合同附件
      delUpload() {
        const checkedList = this.$refs.fileTable.getCheckboxRecords()
        if (!checkedList.length) return this.$message.warning('请选择有效的数据！')
        checkedList.forEach(file => {
          file.delete_flag = 'X'
          const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === file._X_ID)
          this.gridOptionsFile.data.splice(index, 1)
        })
      },
       // 下载文件
      downLoadFile(row) {
        sapDownloadFile(row.xcontent, row.filename)
      },
      // 控件回车
      async handleEnter(e, type, data) {
        console.log('handleEnter', type, data)
        if (!data) return

        switch (type) {
          case 'customer':
            this.conditions.customer = data.customerCode
            this.conditions.cust_name = data.customerName
            this.conditions.customer_type = data.customerType
            // this.conditions.sales_emp_name = data.sales_emp_name
            // this.conditions.sales_emp = data.sales_emp
            // this.conditions.region = data.region
            // this.conditions.region_text = data.bezei
            // this.conditions.city = data.city_code
            // this.conditions.city_text = data.city_name
            // this.resetConditions()
            // this.$set(this.selectDataOptions, 'orgList', data.orgList)
            // this.conditions.sal_center = ''
            // this.conditions.sal_base = ''
            // this.conditions.sal_base_text = ''
            this.saleCenterLists = data.orgList
            this.conditions.sal_center = data.orgList[0].zzfld00001h
            this.conditions.saleCenterTextView = data.orgList[0].mc_short
            // this.conditions.sal_base = data.orgList[0].zzfld00003e
            // this.conditions.sal_base_text = data.orgList[0].mc_short_jd
            this.getCenterFz(this.conditions)
            this.findnewPlanTypeList()
            this.findchflList()
            break
        }
      },
      openDialog(e){
        e.target.blur()
        this.showDialog = true
      },
      // 弹窗内的方法这边来处理，方便数据回调在本页面处理
      async submitHandle() {
        const data = await this.$refs.dialogSelect.submitForm()
        if (data) {
          this.conditions.customer = data.customerCode
          this.conditions.cust_name = data.customerName
          this.conditions.customer_type = data.customerType
          this.saleCenterLists = data.orgList
          this.conditions.sal_center = data.orgList[0].zzfld00001h
          this.conditions.saleCenterTextView = data.orgList[0].mc_short
          this.findnewPlanTypeList()
          this.findchflList()
        }
        this.showDialog = false
        this.getCenterFz(this.conditions)
      },
      saleCenterChange(e){
        const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
        this.conditions.ZZFLD000001Name = checkedData.mc_short
        this.conditions.ZZFLD00003E = checkedData.mc_short_jd
      },
      getSelectDictDataOrigin(dictcode) {
        const formData = new FormData()
        formData.append('code', dictcode)
        apiLoadDictionaryDtl(formData)
          .then(response => {
            this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
          })
          .catch(() => {})
      },
    },
}
</script>
<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
  /deep/ .el-checkbox{
    .el-checkbox__input {
      display: none
    }
  }
  .lg-label{
    /deep/ .el-form-item__label{
      width: 194px !important;
    }
    /deep/ .el-form-item__content{
      width: calc(100% - 204px) !important;
    }
  }
  // /deep/ .el-form-item__content{
  //   width: calc(100% - 100px) !important;
  // }
  .mark{
    font-weight: normal;
    font-size: 12px;
    padding-right: 18px;
    line-height: 24px;
    color: #333;
    /deep/ .el-form-item__label{
      width: 290px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/qy-manage/salePlanApply.vue